<template>
	<div
		class="g-block-title-recruit-card g-block-title-padding"
		:class="{
			'g-block-title-recruit-card--edit': editable,
			'is-active': editable && active,
			'g-block-title-recruit-card--h5': h5,
			'g-block-title-padding--h5': h5,
		}"
		@click="onWrapClick"
	>
		<div class="g-block-title-recruit-card__card" :style="{ background: themeColor }">
			<div class="g-block-title-recruit-card__part g-block-title-recruit-card__part--primary">
				<RichTextEditable
					v-if="editable"
					class="g-block-title-recruit-card__text g-block-title-recruit-card__text--primary"
					fit-content
					:model-value="data.primaryText"
					placeholder="主标题"
					@update:model-value="onPrimaryUpdate"
					@focus="onWrapClick"
				/>
				<div
					v-else
					class="g-block-title-recruit-card__text g-block-title-recruit-card__text--primary"
					v-html="data.primaryText || ''"
				></div>
			</div>

			<div class="g-block-title-recruit-card__meta">
				<span class="g-block-title-recruit-card__meta-line"></span>
				<RichTextEditable
					v-if="editable"
					class="g-block-title-recruit-card__text g-block-title-recruit-card__text--meta"
					fit-content
					:model-value="data.secondaryText"
					placeholder="副标题"
					@update:model-value="onSecondaryUpdate"
					@focus="onWrapClick"
				/>
				<div
					v-else
					class="g-block-title-recruit-card__text g-block-title-recruit-card__text--meta"
					v-html="data.secondaryText || ''"
				></div>
				<span class="g-block-title-recruit-card__meta-line"></span>
			</div>

			<div class="g-block-title-recruit-card__btn">
				<RichTextEditable
					v-if="editable"
					class="g-block-title-recruit-card__text g-block-title-recruit-card__text--btn"
					fit-content
					:model-value="data.buttonText"
					placeholder="按钮文字"
					@update:model-value="onButtonUpdate"
					@focus="onWrapClick"
				/>
				<div
					v-else
					class="g-block-title-recruit-card__text g-block-title-recruit-card__text--btn"
					v-html="data.buttonText || ''"
				></div>
			</div>
		</div>
	</div>
</template>

<script>
	import RichTextEditable from '../../../components/RichTextEditable.vue';
	import { dualTitleMixin } from '../shared/dualTitleMixin.js';

	export default {
		name: 'GBlockTitleRecruitCard',
		components: { RichTextEditable },
		mixins: [dualTitleMixin],
		methods: {
			onButtonUpdate(buttonText) {
				this.$emit('update', { buttonText });
			},
		},
	};
</script>

<style scoped lang="less">
	@import '../shared/titleEditShell.less';

	.g-block-title-recruit-card {
		.title-block-edit-shell();
	}

	.g-block-title-recruit-card__card {
		display: flex;
		flex-direction: column;
		align-items: center;
		padding: 36px 24px 28px;
		border-radius: 15px;
		text-align: center;
	}

	.g-block-title-recruit-card__part {
		display: flex;
		justify-content: center;
		width: 100%;
	}

	.g-block-title-recruit-card__text {
		display: inline-flex;
		justify-content: center;
		line-height: 1.3;
		padding: 0;
		font-family: inherit;
		word-break: break-word;
		white-space: pre-wrap;
		color: #fff;

		&--primary {
			font-size: 26px;
			font-weight: 700;
		}

		&--meta {
			font-size: 14px;
			font-weight: 400;
			flex-shrink: 0;
			padding: 0 10px;
		}

		&--btn {
			font-size: 14px;
			font-weight: 700;
			color: #000;
			letter-spacing: 0.1em;
			text-transform: uppercase;
		}

		:deep(.g-rich-text-editable__content) {
			min-height: unset;
			padding: 0;
			color: inherit;
			text-align: center;
			font-weight: inherit;
		}
	}

	.g-block-title-recruit-card__meta {
		display: flex;
		align-items: center;
		width: 100%;
		margin: 22px 0 26px;
	}

	.g-block-title-recruit-card__meta-line {
		flex: 1;
		height: 1px;
		background: #fff;
		min-width: 16px;
	}

	.g-block-title-recruit-card__btn {
		display: inline-flex;
		align-items: center;
		justify-content: center;
		padding: 10px 32px;
		background: #fff;
		border-radius: 999px;
	}

	.g-block-title-recruit-card--h5 {
		.g-block-title-recruit-card__card {
			padding: 0.72rem 0.48rem 0.56rem;
			border-radius: 0.3rem;
		}

		.g-block-title-recruit-card__text--primary { font-size: 0.52rem; }
		.g-block-title-recruit-card__text--meta { font-size: 0.28rem; padding: 0 0.2rem; }
		.g-block-title-recruit-card__text--btn { font-size: 0.28rem; }
		.g-block-title-recruit-card__meta { margin: 0.44rem 0 0.52rem; }
		.g-block-title-recruit-card__meta-line { min-width: 0.32rem; height: 0.02rem; }
		.g-block-title-recruit-card__btn { padding: 0.2rem 0.64rem; }
	}
</style>
